module.exports = __webpack_public_path__ + "static/ball_2-0f59e3645369e7338dddabc38a66330b.png";